import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
export const queryClient = new QueryClient();
export const UniversalLayoutQueryContainer = ({ children, }) => {
    return (React.createElement(QueryClientProvider, { client: queryClient }, children));
};
//# sourceMappingURL=UniversalLayoutQueryContainer.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
